/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMAddToCartPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';

export const getGTMAddToCartEventData = async (payload: GTMAddToCartPayload) => {
	const { selection, quantity, storeName, orgName, orgId, category } = payload;
	const { sku } = selection ?? {};
	const { name, partNumber, productPrice } = sku ?? {};
	const currency = productPrice?.currency ?? '';
	const hcl_account = orgId ? orgName : null;
	const marketplaceStore = storeName;
	const value = productPrice?.offer;
	const affiliation = 'Dportenis'; // This will later be the Marketplace Seller's organization name

	const brand = findProductAttribute(sku?.attributes ?? [], 'Marca')?.value;
	const size = getValueByPathFromUnknown(selection.attrsByIdentifier, ['Talla']);

	const products = [
		{
			partNumber,
			name,
			quantity,
			currency,
			price: Number(productPrice?.offer),
			category: category?.identifier,
			keyword: sku?.keyword,
			affiliation,
			productPrice,
			brand,
			size,
		},
	];

	return { products, currencyCode: currency, marketplaceStore, hcl_account, value };
};
